// Disable ResizeObserver to prevent errors
import './utils/disableResizeObserver';

import React, { useState } from 'react';
import styled from 'styled-components';
import { AnimatePresence } from 'framer-motion';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DataProvider, useData } from './contexts/DataContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import ProjectModal from './components/ProjectModal';
import LiquidBackground from './components/LiquidBackground';
import LandingPage from './components/LandingPage';
import WebServicesPage from './components/WebServicesPage';
import NotFoundPage from './components/NotFoundPage';
import { Project } from './types';

const AppContainer = styled.div`
  min-height: 100vh;
  background: transparent;
  color: #ffffff;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  position: relative;
  overflow-x: hidden;
`;

const MainContent = styled.main`
  position: relative;
  z-index: 1;
`;

const BackgroundPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(120, 119, 198, 0.2) 0%, transparent 50%);
  z-index: 0;
`;

const PortfolioApp: React.FC = () => {
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const { projects } = useData();

  return (
    <AppContainer>
      <BackgroundPattern />
      <MainContent>
        <Header />
        <Hero />
        <Skills />
        <Projects 
          projects={projects} 
          onProjectSelect={setSelectedProject}
          loading={false}
        />
        <Experience />
      </MainContent>
      <AnimatePresence>
        {selectedProject && (
          <ProjectModal
            project={selectedProject}
            onClose={() => setSelectedProject(null)}
          />
        )}
      </AnimatePresence>
    </AppContainer>
  );
};

const PortfolioRoute: React.FC = () => (
  <>
    <LiquidBackground />
    <PortfolioApp />
  </>
);

const App: React.FC = () => {
  return (
    <DataProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<><LiquidBackground /><LandingPage /></>} />
          <Route path="/professional-profile" element={<PortfolioRoute />} />
          <Route path="/web-services" element={<WebServicesPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </DataProvider>
  );
};

export default App;

